
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Link, Image } from '@ta-interaktiv/contentbricks'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
Manuel Battegay, Mitglied im Leitungsteam der wissenschaftlichen Covid-19-Taskforce, sagt: Aerosol-Übertragungen gebe es, aus Beobachtungen könne man jedoch schliessen: «Sie sind nicht der relevante Teil der Übertragungen.» Dabei stützt sich der Infektiologie-Chefarzt aus Basel auf <Link allowWordWrap href='https://jamanetwork.com/journals/jama/fullarticle/2768396' mdxType="Link">eine Veröffentlichung im Fachblatt «Jama»</Link> vom Juli. Die Autoren um Michael Klompas von der Harvard Medical School fassen dort die Hauptargumente gegen eine Aerosol-Ansteckungen zusammen:
    </p>
    <p>
  <ul>
    <li>Die Reproduktionszahl von Sars-CoV-2 lag Anfang Jahr vor dem Inkrafttreten von Eindäm­mungs­massnahmen bei etwa 2,5. Das heisst, dass ein Infizierter im Durchschnitt 2,5 andere Personen ansteckte. Würden Aerosole eine wichtige Rolle spielen, wäre dieser Wert viel höher gelegen. Erreger wie das Masernvirus, die sich bekanntermassen durch Aerosole verbreiten, sind mit einer Reproduktionszahl von 18 viel ansteckender.</li>
    <li>In Untersuchungen steckten Infizierte nur einen kleinen Teil ihrer engeren Kontaktpersonen an. Ähnliches gilt für medizinisches Personal, das unwissentlich Covid-19-Patienten behandelte. Wären Aerosol-Ansteckungen häufig, wären auch diese Werte höher.</li>
    <li>Aerosol-Infektionen in Chören, Restaurants oder Grossraumbüros sind eher die Ausnahme als die Regel. Sonst wäre die Reproduktionszahl viel höher.</li>
    <li>Die Tatsache, dass in Spitälern und Laborversuchen Virenerbgut in Aerosolen gefunden wird, bedeutet nicht, dass die kleinen Schwebeteilchen auch für Infektionen sorgen. Solche Ansteckungen mit Sars-CoV-2 sind unter Laborbedingungen schwierig nachzuweisen.</li>
  </ul>
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;